"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rolesSlice = rolesSlice;
const rolesInitialState = {
    role: {
        roles: {},
    },
};
function rolesSlice(set) {
    return {
        ...rolesInitialState,
        setRoles({ roles, cardprovider }) {
            set((state) => {
                if (cardprovider === 'HSBC' && roles.manager) {
                    const { manager, ...rest } = roles;
                    state.role.roles = rest;
                }
                else {
                    state.role.roles = roles;
                }
                return state;
            }, false, '[setRoles]');
        },
    };
}
